var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_c('page-header'), _vm._v(" "), _c('top-bar', [_c('h1', {
    staticClass: "naiming-top-bar"
  }, [_vm._v("Contact us")])]), _vm._v(" "), _c('content-wrapper', [_c('div', {
    staticClass: "page-contacts-paragraph"
  }, [_c('p', [_vm._v("Etiam tincidunt laoreet turpis a vulputate. Etiam diam lorem, convallis ac laoreet a, pretium id nisl. Morbi tincidunt nibh a ante fringilla at tincidunt eros venenatis. Nunc a dui mi, in imperdiet sem. Aenean eu nulla massa. Ut interdum tristique est commodo pharetra.")])]), _vm._v(" "), _c('div', {
    staticClass: "address-content"
  }, [_c('span', {
    staticClass: "contacts-h"
  }, [_vm._v("Address")]), _vm._v(" "), _c('address-info', {
    staticClass: "page-contacts-address"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "form-h"
  }, [_vm._v("Send inquiry")]), _vm._v(" "), _c('form-feedback', {
    staticClass: "contacts-form"
  })], 1), _vm._v(" "), _c('page-footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16553579","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/pages/contacts.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-16553579","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/pages/contacts.vue
// module chunks = index